import { Row } from "@freightsimple/ui-core/ComponentLayout/Row";
import { Stack } from "@freightsimple/ui-core/ComponentLayout/Stack";
import { T } from "@freightsimple/ui-core/Typography/T";
import { useBookShipmentBookingProgress } from "../Hooks/useBookShipmentBookingProgress";
import Slider from "@/Shared/Animations/CustomComponents/Slider";
import BookShipmentLoadingText from "../CustomComponents/BookShipmentLoadingText";
import { BookShipmentTipsCarousel } from "../CustomComponents/BookShipmentTipsCarousel";
import {
  BookShipmentBookingProgressFrame,
  BookShipmentBookingProgressSlide,
  BookShipmentBookingProgressStage,
  BookShipmentBookingProgressTrack,
} from "../CustomComponents/Internal/bookShipmentBookingProgressParts";
import type { CompletionResult } from "../BookShipmentProcessingScreen";

interface BookingProgressBarProps {
  onComplete?: ((result: CompletionResult) => void) | undefined;
  isComplete?: boolean | undefined;
}

export function BookShipmentBookingProgressBar({
  onComplete,
  isComplete,
}: BookingProgressBarProps) {
  const { currentStepIndex, currentPercentage, allSteps } =
    useBookShipmentBookingProgress({
      onComplete,
      isExternalComplete: isComplete,
    });

  const carouselSlides = allSteps.map((step) => (
    <BookShipmentBookingProgressSlide
      key={step.title}
      icon={step.icon}
      title={step.title}
      description={step.description}
    />
  ));

  return (
    <BookShipmentBookingProgressFrame>
      <Stack gap={10}>
        <BookShipmentBookingProgressStage>
          <Slider currentIndex={currentStepIndex} children={carouselSlides} />
        </BookShipmentBookingProgressStage>

        <Stack gap={16}>
          <Stack gap={5}>
            <BookShipmentBookingProgressTrack percentage={currentPercentage} />
            <Row justify="between">
              <BookShipmentLoadingText />
              <T size="2xl" weight="bold" testId="booking-progress-percentage">
                {Math.round(currentPercentage)}%
              </T>
            </Row>
          </Stack>

          <BookShipmentTipsCarousel autoRotateInterval={10000} />
        </Stack>
      </Stack>
    </BookShipmentBookingProgressFrame>
  );
}
